/**
 *
 * CustomDate
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import locale from 'antd/es/date-picker/locale/fr_FR';

// styles
import './style.scss';

// antd component
import { Form, DatePicker } from 'antd';

// icons
//import CustomIcons from 'components/CustomIcons';

function CustomDate({
  format,
  label,
  name,
  value,
  required,
  initialValue,
  // actions
  disabledDate,
  onChange,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-date-wrapper', className);

  return (
    <Form.Item
      className={childClassNames}
      key={`${name}-date-select`}
      label={label}
      name={name}
      initialValue={initialValue}
      rules={[
        {
          required: required,
          message: 'Veuillez sélectionner la date',
        },
      ]}
      {...rest}
    >
      <DatePicker
        mode={'date'}
        onChange={onChange}
        disabledDate={disabledDate}
        format={format}
        value={value}
        locale={{
          ...locale,
          lang: {
            ...locale.lang,
            today: 'Aujourd’hui',
            now: 'À présent',
            ok: 'Ok',
          },
        }}
      />
    </Form.Item>
  );
}

CustomDate.defaultProps = {
  required: true,
  label: 'Date',
  format: 'DD.MM.YYYY',
};
CustomDate.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  format: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  disabledDate: PropTypes.func,
};

export default memo(CustomDate);
